import Customer from "./views/Customer";
import CustomerCreateStep1 from "./views/CustomerCreateStep1";
import CustomerCreateStep2 from "./views/CustomerCreateStep2";
import CustomerFormAlamat from "./views/CustomerFormAlamat";
import CustomerDetail from "./views/CustomerDetail";
import CustomerAlamat from "./views/CustomerAlamat";
import CustomerTopFiveLayanan from "./views/CustomerTopFiveLayanan";
import Transaksi from "./../../transaksi-global/transaksi-reguler/views/Transaksi";
import PaketDeposit from "./../paket-deposit/views/PaketDeposit";
import PaketDepositTransaksi from "./../paket-deposit/views/PaketDepositTransaksi";
import TransaksiEpayment from "./../transaksi-epayment/views/TransaksiEpayment";
import CustomerGlobalDetail from "./../snapclean/views/CustomerGlobalDetail";
import TransaksiSnapclean from "./../../transaksi-global/transaksi-snapclean/views/TransaksiSnapclean";
import CustomerGlobalPaylink from "./../snapclean/views/CustomerGlobalPaylink";
import CustomerGlobalTopFiveLayanan from "./../snapclean/views/CustomerGlobalTopFiveLayanan";
import CustomerRiwayatPerubahan from "@/modules/customer/reguler/views/CustomerRiwayatPerubahan";

const requireAuth = {requireAuth: true}
const route = {
	path: '/konsumen',
	component: {
		render(c) {
			return c('router-view')
		}
	},
	children: [
		{
			path: '',
			name: "konsumen",
			component: Customer,
			meta: {
				...requireAuth,
				accessKey: 'customer',
			},
		},
		{
			path: 'create',
			component: {
				render(c) {
					return c('router-view')
				}
			},
			children: [
				{
					path: '1',
					name: "customerCreateStep1",
					component: CustomerCreateStep1,
					meta: {
						...requireAuth,
						accessKey: 'customerRegular.create',
					},
				},
				{
					path: '2',
					name: "customerCreateStep2",
					component: CustomerCreateStep2,
					meta: {
						...requireAuth,
						accessKey: 'customerRegular.create',
					},
				},
				{
					path: 'alamat',
					name: "customerCreateAlamat",
					component: CustomerFormAlamat,
					meta: {
						...requireAuth,
						accessKey: 'customerRegular.create',
					},
				}
			]
		},
		{
			path: 'detail',
			component: {
				render(c) {
					return c('router-view');
				}
			},
			children: [
				{
					path: ':id',
					name: "customerDetail",
					component: CustomerDetail,
					meta: {
						...requireAuth,
						accessKey: 'customerRegular.read',
					},
				},
				{
					path: ':id/edit',
					name: "customerEdit",
					component: () => import('./views/CustomerEdit.vue'),
					meta: {
						...requireAuth,
						// accessKey: 'customerRegular.read',
					},
					props: true,
				},
				{
					path: 'top_five/:idcustomer',
					name: "customerTopFiveLayanan",
					component: CustomerTopFiveLayanan,
					meta: {
						...requireAuth,
						accessKey: 'customerRegular.read',
					},
				},
				{
					path: 'riwayat_perubahan/:idcustomer',
					name: "CustomerRiwayatPerubahan",
					component: CustomerRiwayatPerubahan,
					meta: {
						...requireAuth,
						accessKey: 'customerRegular.read',
					},
				},
				{
					path: 'transaksi/:idcustomer',
					name: "Transaksi",
					component: Transaksi,
					meta: {
						...requireAuth,
						accessKey: 'customerRegular.read',
					},
				},
				{
					path: 'paket_deposit',
					component: {
						render(c) {
							return c('router-view');
						}
					},
					children: [
						{
							path: ':idcustomer',
							name: "PaketDeposit",
							component: PaketDeposit,
							meta: {
								...requireAuth,
								accessKey: 'customerRegular.read',
							},
						},
						{
							path: 'transaksi/:idcustomer/:iddeposit',
							name: "PaketDepositTransaksi",
							component: PaketDepositTransaksi,
							meta: {
								...requireAuth,
								accessKey: 'customerRegular.read',
							},
						},
					]
				},
				{
					path: 'epayment/:idcustomer',
					name: "TransaksiEpayment",
					component: TransaksiEpayment,
					meta: {
						...requireAuth,
						accessKey: 'customerRegular.read',
					},
				},
			]
		},
		{
			path: 'alamat',
			component: {
				render(c) {
					return c('router-view');
				}
			},
			children: [
				{
					path: ':id',
					name: "customerAlamat",
					component: CustomerAlamat,
					meta: {
						...requireAuth,
						accessKey: 'customerRegular.read',
					},
				},
				{
					path: 'create/:idcustomer/:edit?',
					name: "customerCreateNewAlamat",
					component: CustomerFormAlamat,
					meta: {
						...requireAuth,
						accessKey: 'customerRegular.create',
					},
					props: true,
				},
				{
					path: 'edit/:idcustomer/:idalamat',
					name: "customerEditAlamat",
					component: CustomerFormAlamat,
					meta: {
						...requireAuth,
						accessKey: 'customerRegular.update',
					},
				}
			],
		},
		{
			path: 'snapclean',
			component: {
				render(c) {
					return c('router-view');
				}
			},
			children: [
				{
					path: 'detail',
					component: {
						render(c) {
							return c('router-view');
						}
					},
					children: [
						{
							path: ':idcustomer',
							name: "CustomerGlobalDetail",
							component: CustomerGlobalDetail,
							meta: {
								...requireAuth,
								accessKey: 'snapClean.read',
							},
						},
						{
							path: 'transaksi/:idcustomer',
							name: "TransaksiSnapclean",
							component: TransaksiSnapclean,
							meta: {
								...requireAuth,
								accessKey: 'snapClean.read',
							},
						},
						{
							path: 'paylink/:idcustomer',
							name: "CustomerGlobalPaylink",
							component: CustomerGlobalPaylink,
							meta: {
								...requireAuth,
								accessKey: 'snapClean.read',
							},
						},
						{
							path: 'top_five/:idcustomer',
							name: "CustomerGlobalTopFiveLayanan",
							component: CustomerGlobalTopFiveLayanan,
							meta: {
								...requireAuth,
								accessKey: 'snapClean.read',
							},
						},
					]
				}
			],
		}
	]
}


export default router => {
	router.addRoutes([route])
}